import React from 'react';
import { styles } from './Heading.css';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { PossiblyResponsiveValue, useResponsiveValue } from '../../hooks/useResponsiveValue';

type HeadingFontFamily = 'roboto' | 'dom_casual';

export type HeadingProps = {
  color?: string;
  fontFamily?: HeadingFontFamily;
  content?: string;
  icon?: React.ReactNode;
  image?: React.ReactNode;
  isIconStacked?: PossiblyResponsiveValue<boolean>;
};

export const Heading = ({
  color,
  fontFamily = 'roboto',
  content,
  icon,
  image,
  isIconStacked: isIconStackedProp = false,
}: HeadingProps) => {
  const isIconStacked = useResponsiveValue(isIconStackedProp);
  return (
    <div className={styles.container({ hasImage: Boolean(image) })} style={{ color }}>
      {image ? image : null}
      {content ? (
        <HeadingElement fontFamily={fontFamily} isIconStacked={isIconStacked}>
          {icon ? icon : null}
          {content}
        </HeadingElement>
      ) : null}
    </div>
  );
};

const HeadingElement = ({
  children,
  fontFamily,
  isIconStacked,
}: {
  children: React.ReactNode;
  fontFamily: HeadingFontFamily;
  isIconStacked: boolean;
}) =>
  fontFamily === 'dom_casual' ? (
    <DomFont className={styles.heading({ fontFamily, isIconStacked })} as="h2">
      {children}
    </DomFont>
  ) : (
    <h2 className={styles.heading({ fontFamily, isIconStacked })}>{children}</h2>
  );
